import {useTranslation} from "react-i18next";
import {GenerateInputs} from "../GenericInputField";
import React, {useRef, useState} from "react";
import snackbar from "../../snackbar";
import $ from "jquery";
import {apiPut} from "../../api";
import Typography from "@material-ui/core/Typography";
import {ValidatorForm} from "react-form-validator-core";

function DeclineBox(props) {
    const {t, i18n} = useTranslation();
    let inputs = GenerateInputs({
        message: {
            defaultValue: props.globalComment,
            required: true,
            label: t("dialog_plh_decline"),
            type: "textarea"
        }
    });

    let [text, setText] = useState(t("decline_comment"));

    let inputRef = useRef(null);
    let messageWrapper = useRef(null);

    let submit = () => {

        if (!inputs.message.value) {
            snackbar(t("decline_reason"));
            if (messageWrapper && messageWrapper.current) {
                $(messageWrapper.current).find('textarea').focus();
            }
            return false;
        }

        props.dialog.setState({
            okDisabled: true,
            cancelDisabled: true
        });
        return apiPut("sign_request_for_signer/" + props.signerID, {
            declined: true,
            message: inputs.message.value
        }).then((res) => {
            window.formDirty = false;
            props.reloadData();
            snackbar(t("declined"));
            setText(t("declined_message"));
            inputs.disableAll(true);
            props.dialog.setState({
                okDisabled: true,
                cancelDisabled: true
            });
        }, function () {
            props.dialog.setState({
                okDisabled: false,
                cancelDisabled: false
            });
        });
    };

    props.dialog.ok = () => {
        return submit();
    };

    return <div>
        <Typography variant={"body1"}>{text}</Typography>
        <div>
            <ValidatorForm ref={inputRef} onSubmit={submit} noValidate autoComplete="off">
                <div ref={messageWrapper}>
                    {inputs.message.field}
                </div>
            </ValidatorForm>
        </div>
    </div>
}

export default DeclineBox;